// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".underline[data-v-2bbf93e2]{box-sizing:border-box;padding-top:10px}.underline-first[data-v-2bbf93e2]{border-bottom:1px solid #349ff7}.underline-item[data-v-2bbf93e2]{border-bottom:1px solid #b3b4b6;padding-bottom:20px;padding-top:15px}", ""]);
// Exports
module.exports = exports;
